var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeaturedRedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FEE4E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3332 12.6663V12.533C21.3332 11.4129 21.3332 10.8529 21.1152 10.425C20.9234 10.0487 20.6175 9.74274 20.2412 9.55099C19.8133 9.33301 19.2533 9.33301 18.1332 9.33301H13.8665C12.7464 9.33301 12.1863 9.33301 11.7585 9.55099C11.3822 9.74274 11.0762 10.0487 10.8845 10.425C10.6665 10.8529 10.6665 11.4129 10.6665 12.533V19.4663C10.6665 20.5864 10.6665 21.1465 10.8845 21.5743C11.0762 21.9506 11.3822 22.2566 11.7585 22.4484C12.1863 22.6663 12.7464 22.6663 13.8665 22.6663H16.3332M16.3332 15.333H13.3332M15.6665 17.9997H13.3332M18.6665 12.6663H13.3332M19.9998 19.9997V16.333C19.9998 15.7807 20.4476 15.333 20.9998 15.333C21.5521 15.333 21.9998 15.7807 21.9998 16.333V19.9997C21.9998 21.1042 21.1044 21.9997 19.9998 21.9997C18.8953 21.9997 17.9998 21.1042 17.9998 19.9997V17.333",
    stroke: "#D92D20",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedRedIcon);
export default __webpack_public_path__ + "static/media/featured-red-icon.af956e608835a60574230cfa4fb69e78.svg";
export { ForwardRef as ReactComponent };